import React, { useEffect, useState } from "react";
import { Row, Col, Card, Dropdown, Form, Button, Modal } from "react-bootstrap";

import PageTitle from "../../components/PageTitle";
import Table from "../../components/Table";
import { ADMIN_LOGIN_BASE_URL } from "../../apiservices/apiService";
import api from "../../utils/ApiMethod";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { logoutUser } from "../../redux/actions";
import Loader from "../../components/Loader";
import SessionSelectorForNurshing from "../apps/FileManager/SessionSelectorForNurshing";
import ExportNurshingStudentSession from "./ExportNurshingStudentSession";
type RowIdType = string | number;
interface ModalData {
  _id: string;
  name: string;
  enrollment_no: string;
}

const NursingStudentList = () => {
  const [selectedRows, setSelectedRows] = useState<RowIdType[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [originalData, setOriginalData] = useState<any>([]);
  const [getSessionFromSelector, setGetSessionFromSelector] = useState<any>();

  const [toastState, setToastState] = useState(false);

  const [show, setShow] = useState<boolean>(false);
  const [size, setSize] = useState<"sm" | "lg" | "xl">();
  const [idForDelete, setIdForDelete] = useState<ModalData[]>([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const openModalWithSize = (
    size: "sm" | "lg" | "xl",
    id: any,
    first_name: any,
    enrolment_no: any
  ) => {
    setSize(size);
    const data = [id, first_name, enrolment_no];
    setIdForDelete(data);
    handleShow();
  };

  const handleRowSelect = (rowId: RowIdType, isSelected: boolean) => {
    setSelectedRows((prevSelectedRows) =>
      isSelected
        ? [...prevSelectedRows, rowId]
        : prevSelectedRows.filter((id) => id !== rowId)
    );
  };
  const handleSelectOption = (option: string) => {
    setSelectedOption(option);
    if (option === "Select all") {
      const SecondStageID = originalData.filter(
        (datafil: any) => datafil.secondStepStatus !== true
      );
      const allRowIds = SecondStageID.map((row: any) => row._id);
      setSelectedRows(allRowIds);
    }
    if (option === "Export session") {
      const allRowIds = originalData.map((row: any) => row._id);
      setSelectedRows(allRowIds);
    }
  };

  useEffect(() => {
    const option: any = " ";
    setSelectedRows(option);
    handleSelectOption(option);
  }, [getSessionFromSelector]);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const course_name = "02";
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await api.fetchData(`/api/UG/students/${course_name}`);
        if (response.status !== 200) {
          // const errorMsg = await response.json();
          // setIsResponse(errorMsg?.message || "Unknown error occurred.");
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        if (response.status === 440) {
          alert("Session Expired");
          // dispatch(logoutUser());
          window.location.href = `${ADMIN_LOGIN_BASE_URL}/auth/login`; // Use the full URL, including the protocol (http or https)
        }
        setOriginalData(response.data.data);
        // console.log(response.data.data,"api data");
      } catch (error) {
        console.error("Error during fetch:", error);
        // setIsResponse("Error fetching data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSendEmailReminder = () => {
    const course_name = "02";
    const postData = async () => {
      try {
        const formData = new FormData();
        const response = await api.createData(
          `/api/send-reminder/ug/${profileId}/${Key_Key}/${getSessionFromSelector}/${course_name}`,
          formData
        );
        alert("Email Send Successfully");
        if (response.status !== 200) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        if (response.status === 440) {
          alert("Session Expired");
          window.location.href = `${ADMIN_LOGIN_BASE_URL}/auth/login`; // Use the full URL, including the protocol (http or https)
        }
      } catch (error) {}
    };
    postData();
  };

  const { user, userLoggedIn, error, userId } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  let profileId = user._id ? user._id : user.user ? user.user._id : "";
  let Role = user.hobbies ? user.hobbies : user.user.hobbies;
  let profileName = user.name ? user.name : user.user.name;
  let subDepartmentName = user.department
    ? user.department
    : user.user.department;

  const Key_Key = user.moniterd_ttl
    ? user.moniterd_ttl
    : user.user
    ? user.user.moniterd_ttl
    : "";

  const dispatch = useDispatch();

  const deleteStudent = async (itemId: string, nameF: any, e: any) => {
    try {
      const course_name = "02";
      const response = await api.updatePatchDataDelete(
        `/api/${course_name}/student/delete/${profileId}/${Key_Key}/${itemId}`,
        ""
      );
      if (response.status !== 200) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      if (response.status === 440) {
        alert("Session Expired");
        dispatch(logoutUser());
        window.location.href = `${ADMIN_LOGIN_BASE_URL}/auth/login`; // Use the full URL, including the protocol (http or https)
      }
      if (
        response.status == 200 ||
        response.status == 201 ||
        response.status == 204
      ) {
        // alert("Student Record deleted Successfully");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error during deleting student:", error);
    }
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      Cell: ({ row }: { row: any }) => (
        <Form.Check
          type="checkbox"
          checked={selectedRows.includes(row.original._id)}
          onChange={(e) => handleRowSelect(row.original._id, e.target.checked)}
        />
      ),

      sort: false,
    },
    {
      Header: "S.No.",
      accessor: (row: any, index: number) => index + 1,
      sort: true,
    },
    {
      Header: "Enrollment No",
      accessor: "enrollment_no" as const,
      sort: true,
    },
    {
      Header: "Name",
      accessor: (row: any) =>
        `${row.first_name} ${row.middle_name} ${row.last_name}`,
      sort: true,
    },
    {
      Header: "Educational Details",
      accessor: "secondStepStatus",
      Cell: ({ value }: { value: any }) => (
        <span>{value ? "Completed" : "Incomplete"}</span>
      ),
    },
    {
      Header: "Details",
      accessor: "a",
      Cell: ({ row }: { row: any }) => (
        <a href={`/pages/nursing-student-details-page/${row.original._id}`}>
          <i className="uil uil-eye"></i>
        </a>
      ),
      sort: false,
    },
    {
      Header: "Action",
      accessor: "b",
      Cell: ({ row }: { row: any }) => {
        return (
          <div>
            <a
              href={`/page/nurshing-student-edit-details-page/${row.original._id}`}
            >
              <i className="uil uil-edit"></i>
            </a>
            <i
              className="uil uil-trash"
              style={{ marginLeft: "10px" }}
              onClick={() =>
                openModalWithSize(
                  "sm",
                  row.original._id,
                  row?.original?.first_name +
                    " " +
                    row?.original?.middle_name +
                    " " +
                    row?.original?.last_name,
                  row.original.enrollment_no
                )
              }
              // onClick={(e) => deleteStudent(row.original._id, e)}
            ></i>
          </div>
        );
      },
      sort: false,
    },
  ];

  const sizePerPageList = [
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
    {
      text: "All",
      value: originalData.length,
    },
  ];

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Nursing", path: "/pages/mbbs-student-list" },
          {
            label: "Nursing Student List",
            path: "/pages/nursing-student-list",
            active: true,
          },
        ]}
        title={"Nursing Student List"}
      />

      <Row>
        <Col>
          <Dropdown
            onSelect={(eventKey) => eventKey && handleSelectOption(eventKey)}
          >
            <Dropdown.Toggle variant="primary" id="dropdown-basic">
              Select Option
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="Export session" className="d-flex">
                <Form.Check
                  type="checkbox"
                  checked={selectedOption === "Export session"}
                  // onChange={(e) =>
                  //   handleRowSelect(row.original._id, e.target.checked)
                  // }
                />{" "}
                <div> Export session</div>
              </Dropdown.Item>
              <Dropdown.Item eventKey="Select all" className="d-flex">
                <Form.Check
                  type="checkbox"
                  checked={selectedOption === "Select all"}
                  // onChange={(e) =>
                  //   handleRowSelect(row.original._id, e.target.checked)
                  // }
                />{" "}
                <div>Email for stage-2</div>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col>
          <Button
            variant="primary"
            disabled={selectedOption !== "Select all"}
            onClick={handleSendEmailReminder}
          >
            Send reminder email
          </Button>
        </Col>

        <Col>
          {/* <Button
            variant="primary"
            disabled={selectedOption !== "Export session"}
          >
            Export to session
          </Button> */}
          {/* //=====================Export Session code here moved into a seperate component====== */}
          <ExportNurshingStudentSession
            selectedOption={selectedOption}
            selectedRows={selectedRows}
          />
        </Col>
        <Col>
          <div className="inbox-rightbar h-100 pb-0">
            <SessionSelectorForNurshing
              setSessionWiseDataNurshing={setOriginalData}
              setGetSessionFromSelector={setGetSessionFromSelector}
            />
          </div>
        </Col>
      </Row>
      {loading && <Loader />}
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Table
                columns={columns}
                data={originalData}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose} size={size}>
        <Modal.Header onHide={handleClose} closeButton>
          <Modal.Title as="h5">You are Removing Rocord of,</Modal.Title>
          <hr />
        </Modal.Header>
        <Modal.Body>
          <p>
            Id : <strong>{idForDelete[0]}</strong>
          </p>
          <p>
            Stundent Name : <strong>{idForDelete[1]}</strong>
          </p>
          <p>
            {" "}
            Enrollemnt Id : <strong>{idForDelete[2]}</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <p>Confirm your surity.</p>
          <hr />
          <Button onClick={handleClose}>Don't Remove</Button>
          <Button
            onClick={(e) =>
              deleteStudent(idForDelete[0].toString(), idForDelete[1], e)
            }
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NursingStudentList;
